import http from 'plugins/axios';

export default {
  reqList(data) {
    return http.get({
      url: '/admin/pledge/list',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/admin/pledge/add',
      data
    });
  },
  update(data) {
    return http.post({
      url: '/admin/pledge/update',
      data
    });
  },
  getCoinTypes() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  }
  // remove(data) {
  //   return http.get({
  //     url: '/admin/pledge/deleteById',
  //     data: {
  //       id: data
  //     }
  //   });
  // }
};
